import React from "react";
import carImg from "../../assets/images/work-1.jpg";
import ProgressBar from "./progessbar";
import { Link } from "react-router-dom";

const MoreAbout = () => {
    return (
        <section className="more-about mb-8 pt-10 rounded3 position-relative z-1">
            <div className="container">
                <div className="more-about-inner pb-10 px-2 text-center text-xl-start">
                    <div className="row gx-xl-5 gy-5">

                        {/* LEFT SIDE */}
                        <div className="col-xl-7">
                            <div className="section-left">
                                <div className="section-title mb-6">
                                    <h6 className="text-uppercase white fw-medium white mb-1">
                                        Who we are
                                    </h6>
                                    <h2 className="ps-4 border-start border-3 border-green mb-4 white">
                                        create an ultimate world of{" "}
                                        <span className="green">EV generations</span>
                                    </h2>
                                    <Link to="/about" className="btn btn2">
                                        Discover More
                                    </Link>
                                </div>

                                <div className="about-video-wrapper position-relative">
                                    <img
                                        src={carImg}
                                        alt="video thumbnail"
                                        className="w-100 rounded2"
                                    />

                                    <div className="about-video position-absolute top-50 start-50 translate-middle">
                                        <div className="lightgallery-box position-relative">
                                            <div className="promo-video">
                                                <div className="waves-block">
                                                    <div className="waves wave-1 position-absolute rounded-circle z-n1"></div>
                                                    <div className="waves wave-2 position-absolute rounded-circle z-n1"></div>
                                                    <div className="waves wave-3 position-absolute rounded-circle z-n1"></div>
                                                </div>
                                            </div>

                                            <div id="lightgallery-video">
                                                <a
                                                    href="https://youtu.be/VhBl3dHT5SY"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="about-video-play bg-green rounded-circle text-center text-white d-inline-block"
                                                >
                                                    <i className="fa fa-play"></i>
                                                </a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* RIGHT SIDE */}
                        <div className="col-xl-5">
                            <div className="section-body text-white position-relative">
                                <p className="mb-4">
                                    Denial Enterprise provides turnkey electrical and infrastructure solutions tailored for multinational corporations. We bridge the gap between complex grid requirements and efficient charging operations, ensuring your fleet and facilities are always powered.
                                </p>

                                {/* PROGRESS LIST */}
                                <div className="service-list">
                                    <div className="service-list-item">
                                        <ProgressBar title="Eco-friendly Charging" value={90} />
                                    </div>
                                    <div className="service-list-item">
                                        <ProgressBar title="Energy Storage Systems" value={85} />
                                    </div>
                                    <div className="service-list-item">
                                        <ProgressBar title="EV Drivers Services" value={89} />
                                    </div>
                                </div>
                                {/* QUOTE */}
                                <div className="more-about-quote px-4 py-6 bg-green1 rounded2">
                                    <div className="quote-inner ps-4 border-start border-3 border-white">
                                        <p className="mb-2">
                                            "High-Performance Infrastructure. Low-Risk Deployment. Expert MNC Synergy."
                                        </p>
                                        <span className="h6 fw-bold">Deven Vekariya</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default MoreAbout;
